import { forwardRef, type Ref, type SVGProps } from "react";
const IconPointerDownOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 30a1 1 0 0 1-.89-.55l-13-26A1 1 0 0 1 3 2h26a1 1 0 0 1 .89 1.45l-13 26A1 1 0 0 1 16 30M4.62 4 16 26.76 27.38 4Z" />
  </svg>
);
const ForwardRef = forwardRef(IconPointerDownOutlineSVG);
ForwardRef.displayName = "IconPointerDownOutline";
export { ForwardRef as IconPointerDownOutline };
